import { h } from "../../core/dom.js";

export function probabilityBars(ranking, limit = 8) {
  return h("ul", { class: "bars" },
    ranking.slice(0, limit).map((item) => {
      const pct = Math.round(item.probability * 100);
      return h("li", { class: "bar" },
        h("span", { class: "bar-label" }, `${item.emoji} ${item.label_it}`),
        h("span", { class: "bar-track" }, h("span", { class: "bar-fill", style: `width:${pct}%` })),
        h("span", { class: "bar-value" }, `${pct}%`));
    }));
}
